import { cn } from "@app/lib/utils";
import { MarkSvg, SvgOverLayer } from "@assets/icons";
import type { SectorData } from "../data";
import { SectorContent } from "./SectorContent";

interface SectorItemProps {
  sector: SectorData;
  index: number;
  isHovered: boolean;
  imageWidth: string;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick?: () => void;
  isMobile?: boolean;
}

export function SectorItem({
  sector,
  index,
  isHovered,
  imageWidth,
  onMouseEnter,
  onMouseLeave,
  onClick,
  isMobile = false,
}: SectorItemProps) {
  return (
    <div
      key={index}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      className={cn(
        "relative overflow-hidden transition-all duration-700",
        imageWidth,
        isMobile && "cursor-pointer", // Add cursor pointer on mobile
      )}
    >
      {/* Background Image */}
      <img
        src={sector.img}
        alt={`Sector ${index + 1}`}
        className="h-full w-full object-cover object-left-top max-lg:object-bottom"
      />

      {/* Dark overlay when NOT hovered */}
      <div
        className={cn(
          "absolute inset-0 z-0 bg-[#3360ED33] transition-opacity duration-700",
          isHovered ? "opacity-0" : "opacity-100",
        )}
      />

      {/* Overlay gradient + MarkSvg */}
      <div
        className={cn(
          "pointer-events-none absolute inset-0 transition-opacity duration-700",
          isHovered ? "opacity-100" : "opacity-0",
        )}
      >
        <div className="absolute top-0 left-0 z-10 h-fit w-fit ltr:scale-x-1 rtl:scale-x-[-1]">
          <MarkSvg />
        </div>
        <SvgOverLayer color={sector.color} id={`sector_${sector.color}`} />
      </div>

      {/* Sector Content */}
      <SectorContent sector={sector} isHovered={isHovered} />
    </div>
  );
}
